import constants from "./CONSTANTS";

export const initState = {
  user: null,
  isTokenRefreshing: false,
  tokenRefreshingFailed: false,
  login: "",
  session: "",
  regSession: "",
  resPassSession: "",
  loggedIn: false,
  error: "",
  loginAttempts: 0,
  loading: false,
  userMustChangePassword: false,
  ExpirationStatuses: [],
  acceptedTerms: false,
  sendOTPSuccess: false,
  checkUserObj: {},
  isRegsiterSucces: false,
  otpIsValidate: false,
  loginError: 0,

  passwordRecoveredSuccessfully: { success: false, exceptionCode: null },
  identomatObj: {},
  validateIdentomat: {},
  validateInsurer: undefined,
  sendOTPMobileSuccess: false,
  changeMobileSuccess: false,

  isIdentomat: false,

  biometricLoginStatus: { success: null },

  biometricSetup: {
    success: undefined,
    credentialId: null,
  },
  biometricLogin: {
    success: undefined,
    data: null,
  },
  showBiometricPopUp: false,
};

const reducer = (state = initState, action) => {
  switch (action.type) {
    case constants.SET_REFRESHING_TOKEN:
      return {
        ...state,
        isTokenRefreshing: action.isTokenRefreshing,
      };
    case constants.SET_REFRESHING_TOKEN_FAILED:
      return {
        ...state,
        tokenRefreshingFailed: action.tokenRefreshingFailed,
      };
    case constants.SET_LOADING:
      return {
        ...state,
        loading: action.loadingState,
      };
    case constants.LOGIN_SUCCESS:
      return {
        ...state,
        loggedIn: true,
        error: "",
        loading: false,
      };
    case constants.LOGIN_FAIL:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case constants.LOGOUT_USER:
      return { ...initState };
    case constants.USER_MUST_CHANGE_PASSWORD:
      return {
        ...state,
        userMustChangePassword: action.mustChangePassword,
      };
    case constants.SET_APPROVAL_EXPIRATION_STATUS:
      return {
        ...state,
        ExpirationStatuses: action.payload,
      };
    case constants.SET_MAIN_LOGIN_SEND_OTP:
      return {
        ...state,
        sendOTPSuccess: action.payload,
      };
    case constants.SET_MAIN_CHECK_USER:
      return {
        ...state,
        checkUserObj: action.payload,
      };
    case constants.SET_MAIN_REGISTER_USER:
      return {
        ...state,
        isRegsiterSucces: action.payload,
      };
    case constants.SET_MAIN_VALIDATE_OTP:
      return {
        ...state,
        otpIsValidate: action.payload,
      };
    case constants.SET_MAIN_RECOVER_PASSWORD:
      const { success, exceptionCode } = action.payload;
      return {
        ...state,
        passwordRecoveredSuccessfully: { success, exceptionCode },
      };
    case constants.SET_MAIN_START_IDENTOMAT:
      return {
        ...state,
        identomatObj: action.payload,
      };
    case constants.SET_MAIN_VALIDATE_IDENTOMAT:
      return {
        ...state,
        validateIdentomat: action.payload,
      };
    case constants.SET_VALIDATE_INSURER:
      return {
        ...state,
        validateInsurer: action.payload,
      };
    case constants.SET_MAIN_SNED_OTP_TO_MOBILE:
      return {
        ...state,
        sendOTPMobileSuccess: action.payload,
      };
    case constants.SET_MAIN_CHANGE_MOBILE:
      return {
        ...state,
        changeMobileSuccess: action.payload,
      };
    case constants.SET_LOGIN_REQ:
      return {
        ...state,
        loginError: action.payload,
      };
    case constants.SET_MAIN_TO_IDENTOMAT:
      return {
        ...state,
        isIdentomat: action.payload,
      };
    case constants.SET_BIOMETRIC_LOGIN_STATUS:
      return {
        ...state,
        biometricLoginStatus: action.payload,
      };

    case constants.SET_BIOMETRIC_SETUP:
      return {
        ...state,
        biometricSetup: {
          ...state.biometricSetup,
          ...action.payload,
        },
      };

    case constants.SET_BIOMETRIC_LOGIN:
      return {
        ...state,
        biometricLogin: {
          ...state.biometricLogin,
          ...action.payload,
        },
      };
    case constants.SET_SHOW_BIOMETRICS_MODAL:
      return {
        ...state,
        showBiometricPopUp: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
